import APIModel from "../APIModel";

export default class ApplicationRequests extends APIModel {
  private readonly resourceUrl: string;

  constructor() {
    super();
    this.resourceUrl = "applications";
  }

  async getData(params: object): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}`, params);
  }

  async previewById(id: number): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500, 404)
      .get(`${this.resourceUrl}/${id}/preview`, {});
  }

  async getForEdit(id: number): Promise<any> {
    return await this.http.get(`${this.resourceUrl}/${id}/edit`);
  }

  async getList(params: any = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(500)
      .get(`${this.resourceUrl}/list`, params);
  }

  async edit(id: number, data: object): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .get(`${this.resourceUrl}/${id}/edit`, data);
  }

  async create(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .post(`${this.resourceUrl}`, payload);
  }

  async update(payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .patch(`${this.resourceUrl}/${payload.id}`, payload);
  }

  async delete(id: any): Promise<any> {
    return await this.http.delete(`${this.resourceUrl}`, { id });
  }

  async cancel(id: number): Promise<any> {
    return await this.http.patch(`${this.resourceUrl}/${id}/cancel`, {});
  }

  async enroll(id: number, payload: any): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .patch(`${this.resourceUrl}/${id}/enroll`, payload);
  }

  async setStatusVerify(id: number, payload: any = {}): Promise<any> {
    return await this.http
      .ignoreErrorHandler(422)
      .patch(`${this.resourceUrl}/${id}/verified`, payload);
  }

  async getAvailablePlaces(payload: any): Promise<any> {
    return this.http
      .ignoreErrorHandler(422)
      .get(`${this.resourceUrl}/application_speciality_places`, payload);
  }

  async getRatingTable(params: any = {}): Promise<any> {
    return this.http
      .ignoreErrorHandler(422)
      .getAxiosInstance()
      .get(`${this.resourceUrl}/rating`, params);
  }
}
